import React, { ChangeEvent } from 'react';
import Loja from '~/components/Loja';
import { Row, Col } from 'react-bootstrap';
import { useFluxoDeCaixa } from '../../hook/useFluxoDeCaixa';
import { FormActions } from '../FormActions';
import { InputDate, MultiContaBanco } from '~/components/NovosInputs';

export const FormFilters: React.FC = () => {
  const {
    formTela,
    handleChangeLojas,
    lojas,
    cleanCC,
    setCleanCC,
    disabledFields,
  } = useFluxoDeCaixa();
  const { register, control, formState, setValue, clearErrors, watch } =
    formTela;
  const { errors } = formState;
  return (
    <>
      <Row>
        <Col sm={12} md={12}>
          <Loja
            isMulti
            onChange={(val: number | number[]) => {
              handleChangeLojas(val);
            }}
            disabled={disabledFields}
            selectedLoja={lojas}
            isDisabled={false}
          />
        </Col>
      </Row>
      <Row>
        <Col sm={12} md={12} className="mt-4">
          <MultiContaBanco
            lojas={lojas}
            resetContas={cleanCC}
            disabled={disabledFields}
            onChange={(value: number | number[]) => {
              setCleanCC(false);
              setValue('cod_cc', value);
            }}
          />
        </Col>
      </Row>
      <Row>
        <div
          style={{
            display: 'flex',
            gap: '35px',
            justifyContent: 'center',
          }}
        >
          <Col md={2} sm={12}>
            <InputDate
              control={control}
              register={register}
              name="dta_inicio"
              label="Data de Início"
              isError={!!errors.dta_inicio}
              disabled={disabledFields}
              onChange={(e: ChangeEvent<HTMLInputElement>) => {
                clearErrors('dta_inicio');
                setValue('dta_inicio', e.target.value);
              }}
            />
          </Col>
          <Col md={2} sm={12}>
            <InputDate
              control={control}
              register={register}
              name="dta_final"
              label="Data do Fim"
              minDate={watch('dta_inicio')}
              isError={!!errors.dta_final}
              disabled={disabledFields}
              onChange={(e: ChangeEvent<HTMLInputElement>) => {
                clearErrors('dta_final');
                setValue('dta_final', e.target.value);
              }}
            />
          </Col>
          <FormActions />
        </div>
      </Row>
    </>
  );
};
